import { useState, useEffect } from "react";

export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    isMobile: false,
    isTablet: false,
    isLaptop: false,
    isDesktop: false,
    width: undefined,
    height: undefined,
  });

  const mobileWidth = 480;
  const tabletWidth = 768;
  const laptopWidth = 1299;

  useEffect(() => {
    function handleResize() {
      const width = typeof window == 'undefined' ? 0 : window.innerWidth;
      const height = typeof window == 'undefined' ? 0 : window.innerHeight;
      setWindowSize({
        width,
        height,
        isMobile: width <= mobileWidth,
        isTablet: width <= tabletWidth,
        isLaptop: width <= laptopWidth,
        isDesktop: width > laptopWidth,
      });
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}
